import React from "react";
import styles from '../HelpPage.module.css';

const FAQs = () => {
    return (
        <section className={styles.helpSection}>
        <h2>FAQs</h2>

        <details className={styles.collapsibleSection}>
        <summary className={styles.sectionSummary}>
            How accurate is the AI-generated content?
        </summary>
        <div className={styles.sectionContent}>
            <p className={styles.sectionDescription}>
            Our AI generates high-quality, marketplace-compliant content based on the information you provide. The more details you include in your product information, the more accurate and tailored the results will be.
            </p>
        </div>
        </details>

        <details className={styles.collapsibleSection}>
        <summary className={styles.sectionSummary}>
            Can I edit the generated content?
        </summary>
        <div className={styles.sectionContent}>
            <p className={styles.sectionDescription}>
            Currently, you cannot edit the generated content directly in the platform. You can copy the content and edit it externally, or regenerate content with modified inputs if you want changes.
            </p>
        </div>
        </details>

        <details className={styles.collapsibleSection}>
        <summary className={styles.sectionSummary}>
            How long does it take to generate content?
        </summary>
        <div className={styles.sectionContent}>
            <p className={styles.sectionDescription}>
            Most generations take less than a minute for single listings. Bulk generations will take longer depending on the number of products.
            </p>
        </div>
        </details>

        <details className={styles.collapsibleSection}>
        <summary className={styles.sectionSummary}>
            What file formats are supported for image uploads?
        </summary>
        <div className={styles.sectionContent}>
            <p className={styles.sectionDescription}>
            We support JPG and PNG formats. For best results, use PNG images with transparent backgrounds, especially for infographic generation.
            </p>
        </div>
        </details>

        <details className={styles.collapsibleSection}>
        <summary className={styles.sectionSummary}>
            What are the image size limitations?
        </summary>
        <div className={styles.sectionContent}>
            <p className={styles.sectionDescription}>
            Each image can be up to 5MB in size. You can upload up to 5 images per product.
            </p>
        </div>
        </details>

        <details className={styles.collapsibleSection}>
        <summary className={styles.sectionSummary}>
            How do I organize images for bulk upload?
        </summary>
        <div className={styles.sectionContent}>
            <p className={styles.sectionDescription}>
            Create a ZIP file containing folders named exactly like your Model Numbers. Each folder can contain up to 5 images for that specific product.
            </p>
        </div>
        </details>

        <details className={styles.collapsibleSection}>
        <summary className={styles.sectionSummary}>
            What does 1 credit allow me to do?
        </summary>
        <div className={styles.sectionContent}>
            <p className={styles.sectionDescription}>
            Each credit allows you to generate content for one product. This applies to single listings, bulk listings (1 credit per product), image generation, and product copy generation.
            </p>
        </div>
        </details>

        <details className={styles.collapsibleSection}>
        <summary className={styles.sectionSummary}>
            How do I download my generated content?
        </summary>
        <div className={styles.sectionContent}>
            <p className={styles.sectionDescription}>
            After content generation, you can download text content as CSV files and images as ZIP files. The download options will be available after the generation process completes.
            </p>
        </div>
        </details>

        <details className={styles.collapsibleSection}>
        <summary className={styles.sectionSummary}>
            What if I need help using the platform?
        </summary>
        <div className={styles.sectionContent}>
            <p className={styles.sectionDescription}>
            Click on "Help / Support" in the left navigation menu to access support resources.
            </p>
        </div>
        </details>

        <details className={styles.collapsibleSection}>
        <summary className={styles.sectionSummary}>
            How do I provide feedback about the platform?
        </summary>
        <div className={styles.sectionContent}>
            <p className={styles.sectionDescription}>
            Click on "Feedback" in the left navigation menu to share your thoughts and suggestions.
            </p>
        </div>
        </details>
        
    </section>
    );
};

export default FAQs;